import React from 'react'
import { Row, Container } from 'react-bootstrap';
import './casestudybody30.css';

import clientimg from '../images/case-study-client30.webp'
import outcome from '../images/outcome30.webp'

import sm1 from '../images/cs30so1.webp'
import sm2 from '../images/cs30so2.webp'
import sm3 from '../images/cs30so3.webp'
import sm4 from '../images/cs30so4.webp'



const Casestudybody30 = () => {

    return (
        <>
        <section className='casestudybody30-section'  >
          <Container>

            <Row className='w-100 py-md-5 py-4 clintrow'>
                <div className='col-md-4 relative order-1'>
                  <div className='left-box'>
                    <div className='content-box'>
                      <h2>About</h2>
                      {/* <div className="h1"><span className='h1 animate-underline' style={{ paddingBottom: "40px" }}>The Client</span></div> */}
                      <div className="h1">The Client</div>
                      <p className='anima '><span className='only-anima-underline' > **** </span></p>
                      <p>The client is a real estate fund manager, offering services in dealing, investment fund management, and custody activities. They specialize in asset management and real estate funds</p>
                    </div>
                  </div>
                           
                </div>
                <div className='col-md-8 right-box'>
                    <img src={clientimg} alt="" />
                </div>
            </Row>
       
            <Row className='mt-md-5'>
              <div className='col-md-12'>
                <div className='content-box'>
                  <h2>Situation</h2>
                  {/* <div className="h1"><span className='h1 animate-underline' style={{ paddingBottom: "40px" }}>The Client</span></div> */}
                  <div className="h1">Overview</div>
                  <p className='anima '><span className='only-anima-underline' > **** </span></p>
                  <p>The client aims to enhance their investment strategy by developing a comprehensive analysis of the REIT market. The primary objective is to identify key growth opportunities, fees benchmarking and provide strategic recommendations for portfolio diversification and risk management</p>
                </div>
                
              </div>
            </Row>
          </Container>
        </section>
    
        <section className='casestudybody30-section bg-gredient-dark'>
          <Container>
            <Row>
              <div className='col-md-12'>
                  <div className='content-box'>
                    <h2>Approach &</h2>
                    {/* <div className="h1"><span className='h1 animate-underline' style={{ paddingBottom: "40px" }}>The Client</span></div> */}
                    <div className="h1">Methodology</div>
                    <p className='anima '><span className='only-anima-underline' > **** </span></p>
                    {/* <p>The next step was to put together and implement a step-by-step process for conducting the valuation:</p> */}
                  
                    <div className='list-text my-3'>
                        <div className='icon'>
                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="11.5" cy="11.5" r="11" fill="#03A393" stroke="white"/>
                        </svg>
                        </div>
                        <div className='text'>
                          <h4>Data Collection: </h4>
                          <p>Gathered detailed data through <span style={{color:"#01C6B2"}}>market capitalization analysis, historical growth trends, and peer benchmarking</span> across listed and unlisted REITs within the real estate sector</p>
                        </div>
                      </div>
    
                      <div className='list-text my-3'>
                        <div className='icon'>
                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="11.5" cy="11.5" r="11" fill="#03A393" stroke="white"/>
                        </svg>
                        </div>
                        <div className='text'>
                          <h4>Analysis:</h4>
                          <p>Conducted a robust <span style={{color:"#01C6B2"}}>SWOT analysis and financial forecasting to evaluate procurement dynamics and investment opportunities.</span> This helped in shaping strategies aligned with sectoral performance and future growth outlook</p>
                        </div>
                      </div>
    
                      <div className='list-text my-3'>
                        <div className='icon'>
                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="11.5" cy="11.5" r="11" fill="#03A393" stroke="white"/>
                        </svg>
                        </div>

                        <div className='text'>
                          <h4>Client Engagement:</h4>
                          <p>Worked closely with client stakeholders to <span style={{color:"#01C6B2"}}>define key performance metrics, refine output formats,</span> and ensure alignment with the client's broader strategic and procurement objectives</p>
                        </div>
                      </div>

                      <div className='list-text my-3'>
                        <div className='icon'>
                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="11.5" cy="11.5" r="11" fill="#03A393" stroke="white"/>
                        </svg>
                        </div>

                        <div className='text'>
                          <h4>Report Design: </h4>
                          <p>Created a comprehensive report that <span style={{color:"#01C6B2"}}>summarized key insights, highlighted sector trends, and provided customized recommendations to support strategic investment decisions</span></p>
                        </div>
                      </div>                 

                      <div className='list-text last-child my-3'>
                        <div className='icon'>
                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="11.5" cy="11.5" r="11" fill="#03A393" stroke="white"/>
                        </svg>
                        </div>

                        <div className='text'>
                          <h4>Delivery Mechanism:</h4>
                          <p>Designed and delivered a <span style={{color:"#01C6B2"}}>dashboard to visualize performance, strategic opportunities, and key financial indicators,</span> enabling data-driven decisions with clarity and speed</p>
                        </div>
                      </div> 
                     
                      <h3 className='mt-5'>Sample Output</h3>
                      <div className='sample-output mt-3'>
                        <img src={sm1} alt=''/>
                        <img src={sm2} alt=''/>
                        <img src={sm3} alt=''/>
                        <img src={sm4} alt=''/>
                      </div>
                  </div>
                  
                </div>
            </Row>
          </Container>
        </section>

    
        <section className='casestudybody30-section outcome'  >
          <Container>
            <Row className='w-100 pb-5 clintrow '>
                <div className='col-md-4 relative order-1'>
                  <div className='left-box'>
                    <div className='content-box'>
                      <div className="h1">Outcome</div>
                      <p className='anima '><span className='only-anima-underline' > **** </span></p>
                      <p>The client successfully leveraged the REIT market analysis and developed a comprehensive investment strategy that enhanced their portfolio capabilities, streamlined operations, and positioned them for future growth</p>  
                    </div>
                  </div>
                           
                </div>
                <div className='col-md-8 right-box'>
                    <img src={outcome} alt="" />
                </div>
            </Row>
       
          </Container>
        </section>
    
        </>  
      )
    }

export default Casestudybody30
